<template>
  <div class="tourleader-page__reviews">
    <h4
      class="mt-4 md:mt-0 text-2xl !font-bold pl-2"
      data-i18n="tourleader.reviews.title"
    >
      {{ $t('tourleader.reviews.title') }}
    </h4>
    <Pill
      v-if="!loading && formattedReviews.length === 0"
      color="lightest-gray"
      data-i18n="tourleader.reviews.none"
    >
      {{ $t('tourleader.reviews.none') }}
    </Pill>
    <TestimonialsTab
      v-else
      class="pt-0 md:pt-0"
      :loading="loading"
      :reviews="formattedReviews"
      :reviews-average="{}"
      :ratings-chart="{}"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  id: {
    type: String,
    default: null,
  },
  reviews: {
    type: Array,
    default: () => [],
  },
})

const loading = ref(true)

const formattedReviews = computed(() => {
  return (props.reviews || [])
    .map(item => ({
      ...item,
      from: item?.tripname,
    }))
})

onMounted(() => {
  loading.value = false
})
</script>
